import {
    afterNextRender,
    Component,
    computed,
    inject,
    signal,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChatTooltipComponent } from "../chat-tooltip/chat-tooltip.component";
import { Icon } from "@malirang/front-share";
import { CenterStore } from "../../../../../stores/center/center.store";
import { Router, RouterLink } from "@angular/router";
import { injectNavigationEnd } from "ngxtension/navigation-end";
import { GuardStore } from "../../../../../guards/guard.store";

@Component({
    selector: "app-create-schedule-completeness",
    templateUrl: "./create-schedule-completeness.component.html",
    styleUrls: [
        "./create-schedule-completeness.component.css",
        "../center-completeness.component.css",
    ],
    imports: [CommonModule, ChatTooltipComponent, Icon, RouterLink],
})
export class CreateScheduleCompletenessComponent {
    readonly centerStore = inject(CenterStore);
    readonly router = inject(Router);
    readonly guardStore = inject(GuardStore);

    completenessError = this.guardStore.completenessError;
    currentCenter = this.centerStore.currentCenter;
    completeness = computed(() => this.currentCenter()?.completeness);

    navigationEnd$ = injectNavigationEnd();

    open = signal(false);

    setStyleFlag = computed(
        () =>
            this.completenessError() === "4" ||
            (!this.completeness()?.createSchedule &&
                this.completeness()?.childWithService),
    );

    constructor() {
        afterNextRender(() => {
            this.openTooltip();

            this.navigationEnd$.subscribe(() => {
                this.open.set(false);
                this.openTooltip();
                this.handleError();
            });

            this.guardStore.completenessError$.subscribe({
                next: () => {
                    this.handleError();
                },
            });
        });
    }

    handleError() {
        const error = this.completenessError();
        const url = this.router.url;
        if (error === "4" && url.includes("/schedule")) {
            this.guardStore.setCompletenessError(null);
            return;
        }
    }

    openTooltip() {
        const url = this.router.url;

        if (url.includes("/schedule")) {
            this.open.set(true);
        }
    }
}
